export default {
  appointment: null,
  patient: null
}
